
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/defi",
      function () {
        return require("private-next-pages/defi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/defi"])
      });
    }
  